// import _ from 'lodash'

// const DEFAULTS = {
//   fields : ['flex', 'flex-col', 'justify-end', 'pt-6'],
//   labels: ['absolute', 'cursor-pointer', 'relative', 'transform-gpu', 'translate-x-2', 'origin-left'],
//   focus : ['scale-75', 'translate-y-3'],
//   blur : ['scale-100', 'translate-y-8'],
// }

/**
 * Safely add classes to an element.
 * @param {Element} element 
 * @param {array} classes 
 */
// const addClasses = (element, classes) => {
//   _.each(classes, (c) => {
//     element.classList.add(c)
//   })
// }

/**
 * Safely remove classes from an element.
 * @param {Element} element 
 * @param {array} classes 
 */
//  const removeClasses = (element, classes) => {
//   _.each(classes, (c) => {
//     if(element.classList.contains(c)){
//       element.classList.remove(c)
//     }
//   })
// }

/**
 * Adds Material-like functionality to a Gravity Form.
 */
class MaterialMarketoForm {
  waitForForm() {
    // const targetNode = document.querySelector('.mktoForm'),
    //   config = {
    //     attributes: true,
    //     childList: true,
    //     subtree: true,
    //   },
    //   callback = function(mutationsList, observer) {
    //     console.log('observed')
    //   },
    //   observer = new MutationObserver(callback)
    //   observer.observe(targetNode, config)
  }

  constructor() {
    this.waitForForm()
  }
}

export default MaterialMarketoForm


// WEBPACK FOOTER //
// ./scripts/components/MaterialMarketoForm.js